export const dropbox = (asset) =>
  new URL('https://via.placeholder.com/400').href;

export const assetRef = (asset) =>
  new URL(asset, 'https://backlight.dev/assets/').href;
